interface GeoLocation {
  lat: number;
  lng: number;
}

interface Filter {
  activityCode?: string;
  legalParams?: {
    category?: string;
    code?: string;
    country?: string;
  };
  geoLocations?: GeoLocation[];
}

interface Search {
  what?: string;
  who?: string;
  where?: string;
}

interface Aggregation {
  name: string;
  agg: any;
}

export interface QueryParameters {
  index?: string;
  size?: number;
  from?: number;
  data?: any;
  search?: string;
  filter?: Filter;
  aggs?: Aggregation[];
}

const buildSearchQuery = (search?: string) => {
  if (search) {
    return [
      { multi_match: { query: search, fields: ['activity.name', 'legal.name'] } },
      { multi_match: { query: search, fields: ['name', 'contacts'] } },
    ];
  }

  return [{ match_all: {} }]; // Match all query
};

const buildFilterQuery = (filter?: Filter) => {
  return [
    filter?.activityCode ? { term: { 'activity.code.keyword': filter.activityCode } } : null,
    filter?.legalParams
      ? {
          term: {
            'legal.category.keyword': filter.legalParams.category,
            'legal.code.keyword': filter.legalParams.code,
            'legal.country.keyword': filter.legalParams.country,
          },
        }
      : null,
    // where
    //   ? {
    //     bool: {
    //       should: [
    //         {
    //           geo_distance: {
    //             distance: '10km', // Adjust the distance as needed
    //             'address.lat': 40.73, // Replace with the actual latitude
    //             'address.lng': -73.93, // Replace with the actual longitude
    //           },
    //         },
    //         // Add more geo queries as needed
    //       ],
    //     },
    //   }
    //   : undefined,
  ].filter(Boolean);
};

const buildAggsQuery = (aggs?: Aggregation[]) => {
  return aggs
    ? aggs.reduce((acc, next) => {
        acc[next.name] = next.agg;
        return acc;
      }, {})
    : {};
};

export const buildDslQuery = ({ search, filter, aggs }: QueryParameters) => {
  const query: any = {
    query: {
      bool: {
        should: buildSearchQuery(search),
        filter: buildFilterQuery(filter),
      },
    },
    aggs: buildAggsQuery(aggs),
  };

  return query;
};
